module.exports = __webpack_public_path__ + "3f16e137/img/google.68f3823e.svg";